<!-- Spacer -->
<div
    class="treo-horizontal-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
